module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_1.1d18eb94.png";